import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { Box, Button, FlexGrid, StackView } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';

import TankNumber from './components/tankNumber';
import TankName from './components/tankName';
import TankProduct from './components/tankProduct';
import TankType from './components/tankType';
import TankHeight from './components/tankHeight';
import Gauge from './components/gauge';
import TankCapacity from './components/tankCapacity';

const AddDetailsFormPropane = ({
  tankDetailsFarmAndRanch,
  setTankDetailsFarmAndRanch,
  sectionError
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    assigneeSRTModal: { addButton }
  } = localizedStrings;

  const initialState = {
    valueTankNumber: '',
    valueTankName: '',
    valueTankProduct: '',
    valueTankType: '',
    valueTankHeight: '',
    valueTankCapacity: '',
    valueTankGauge: ''
  };

  const [dataField, setDataField] = useState(initialState);
  const [error, setError] = useState('');

  const validateForm = () =>
    [
      'valueTankNumber',
      'valueTankName',
      'valueTankProduct',
      'valueTankType',
      'valueTankHeight',
      'valueTankGauge',
      'valueTankCapacity'
    ].every(field => dataField[field] !== '');

  const onAddInfo = () => {
    if (!validateForm()) {
      setError('Please enter all necessary information');
      return;
    }
    setTankDetailsFarmAndRanch({
      ...tankDetailsFarmAndRanch,
      propane: [...tankDetailsFarmAndRanch.propane, dataField]
    });
    setDataField(initialState);
    setError('');
  };

  useEffect(() => {
    setError(sectionError);
  }, [sectionError]);

  return (
    <StackView space={3}>
      <FlexGrid>
        <FlexGrid.Row>
          <FlexGrid.Col>
            <StackView space={3}>
              <TankNumber
                dataField={dataField}
                setDataField={setDataField}
                error={error}
              />
              <TankName
                dataField={dataField}
                setDataField={setDataField}
                error={error}
              />
              <TankProduct
                typeKey="propane"
                dataField={dataField}
                setDataField={setDataField}
                fieldOptions={['Propane']}
                error={error}
              />
              <TankType
                typeKey="propane"
                dataField={dataField}
                setDataField={setDataField}
                fieldOptions={['Horizontal', 'Vertical']}
                error={error}
              />
              <TankHeight
                dataField={dataField}
                setDataField={setDataField}
                error={error}
              />
              <TankCapacity
                dataField={dataField}
                setDataField={setDataField}
                error={error}
              />
              <Gauge
                typeKey="propane"
                dataField={dataField}
                setDataField={setDataField}
                fieldOptions={['2in', '1,7in']}
                error={error}
              />
            </StackView>
          </FlexGrid.Col>
        </FlexGrid.Row>
      </FlexGrid>
      <Box style={{ padding: '1.5rem' }}>
        <Button onPress={onAddInfo}>{addButton}</Button>
      </Box>
    </StackView>
  );
};

AddDetailsFormPropane.propTypes = {
  tankDetailsFarmAndRanch: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setTankDetailsFarmAndRanch: PropTypes.func.isRequired,
  sectionError: PropTypes.string.isRequired
};

export default AddDetailsFormPropane;
